import { action, observable, runInAction, makeObservable } from 'mobx';
import { request } from '@/framework/network/request'
import MenuData from '@home/model/MenuData'


export default class MenuTableLayoutStore {
  loading:boolean;
  hasMore:boolean
  menuData:Array<MenuData>
  menuPages:number
  menuSearch:object


  constructor () {
    makeObservable(this,{
      loading: observable,
      hasMore: observable,
      menuPages: observable,
      getMenuData: action
    })
    this.loading = false
    this.hasMore = false
    this.menuPages = 0
    this.menuSearch = {}
    this.menuData = []
  }

  getMenuData = async (page:number = 0,size:number = 10) => {
    this.loading = true
    this.hasMore = true
    try {
      const res = await request.get('/pa/question:search',{page: page, size: size,...this.menuSearch })
      runInAction(() => {
        this.menuPages = res.data.totalPages
        this.hasMore = res.data.totalPages > page
        this.menuData = this.menuData.concat(res.data.content)
        this.loading = false
        console.log("page",page,"res",res,"this.hasMore",this.hasMore,"this.menuData",this.menuData)
      })
    }catch (error){
      console.error("错误警告:",error)
    }
  }
}
